import { render, staticRenderFns } from "./ehc-button-small.vue?vue&type=template&id=2a0d6422"
import script from "./ehc-button-small.vue?vue&type=script&lang=js"
export * from "./ehc-button-small.vue?vue&type=script&lang=js"
import style0 from "./ehc-button-small.vue?vue&type=style&index=0&id=2a0d6422&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports